<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-text>
        <v-container>
          <v-text-field
            v-model="youtubecode"
            label="Код youtube"
            required
          ></v-text-field> </v-container
      ></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeHandler">Закрыть</v-btn>
        <v-btn color="blue darken-1" text @click="saveHandler">Добавить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      youtubecode: ''
    }
  },
  methods: {
    closeHandler() {
      this.$emit('close')
    },
    saveHandler() {
      this.$emit('save', this.youtubecode)
    }
  }
}
</script>

<style></style>
